import { EmployeeAttachment } from "../../types/EmployeeAttachment";
import {
  EmployeeAttachmentActions,
  EmployeeAttachmentActionList,
} from "../actions/empAttachAction";

const initialValue: Array<EmployeeAttachment> = [];

export const employeeAttachmentReducer = (
  state: EmployeeAttachment[] = initialValue,
  action: EmployeeAttachmentActions,
): EmployeeAttachment[] => {
  switch (action.type) {
    case EmployeeAttachmentActionList.ADD_ATTACHMENT:
      return [...state, action.data];

    case EmployeeAttachmentActionList.EDIT_ATTACHMENT: {
      const updated = [...state];
      const index = updated.findIndex((att) => att.id === action.data.id);
      if (index > -1) {
        updated[index] = { ...action.data };
      }
      return updated;
    }

    case EmployeeAttachmentActionList.FETCH_ATTACHMENT_BY_ID: {
      const updated = [...state];
      const index = updated.findIndex((att) => att.id === action.data?.id);

      if (action.data) {
        if (index > -1) {
          // Update existing attachment with fetched one
          updated[index] = { ...action.data };
        } else {
          // If not found, add new one
          updated.push(action.data);
        }
      }
      return updated;
    }

    case EmployeeAttachmentActionList.FETCH_ATTACHMENTS:
      return action.data;

    case EmployeeAttachmentActionList.DELETE_ATTACHMENT:
      return state.filter((att) => att.id !== action.data);

    default:
      return state;
  }
};
